<template>
  <div>
    <link type="text/css" rel="stylesheet" href="/css/posterTvGrid.css"/>
    <link type="text/css" rel="stylesheet" href="/css/backSideStyle_custom.css"/>
    <nav class="navbar Customize navbar-light">
      <a class="navbar-brand" href="/backend"
        ><img
          src="/images/backend/favicon.png"
          alt="首頁圖示"
          class="logo_01"
        />
        國立臺灣大學生物產業傳播暨發展學系 — 後台管理系統</a
      >
    </nav>
    <div class="sub-title"><span>歡迎登入！<a href="/backend/">{{ userName }}</a></span></div>
    <b-container fluid>
      <b-row>
        <b-col cols="auto">
          <div style="width: 320px">
            <SideBar></SideBar>
          </div>
        </b-col>
        <b-col>
          <router-view />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="logOut" title="提示" ok-only :no-close-on-backdrop="true" :no-close-on-esc="true" hide-header no-stacking>
      <template #modal-footer>
        <button
          class="btn btn-success btn-sm m-1"
          @click="goHome"
        >
          確定
        </button>
      </template>
      <p class="my-4">{{ message }}</p>
    </b-modal>    
    <b-modal v-model="logOutConfirm" title="提示" ok-only :no-close-on-backdrop="true" :no-close-on-esc="true" hide-header no-stacking>
      <template #modal-footer>
        <button
          class="btn btn-success btn-sm m-1"
          @click="goLogIn"
        >
          繼續操作
        </button>
        <button
          class="btn btn-success btn-sm m-1"
          @click="goLogOut"
        >
          直接登出
        </button>
      </template>
      <p class="my-4">{{ message }}</p>
    </b-modal>
  </div>
</template>

<script>
import SideBar from "@/components/admin/NavBar/sideBar.vue";
export default{
  name: "index_admin",
  components:{
    SideBar,
  },
  data(){
    return{
      //使用者名稱
      userName: "",
      //內容訊息
      message:null,
      //登出
      logOut:false,
      //登出確認
      logOutConfirm:false,
      //呼叫背景登入 API 
      apiBackendLogin:(data) => 
        this.userRequest.post("bicd/BackendLogin", data),
    };
  },
  mounted() {
    //確認是否登入
    this.adminCheckLogin()
  },
  watch: {
    "$route.query"() {
      //確認是否登入
      this.adminCheckLogin()
    },
  },
  methods: {
    //確認是否登入
    adminCheckLogin() {
      clearInterval(this.timeOutRefresh);
      this.timeOutRefresh = setInterval(() => {
        this.CheckLogin();
      }, 5000);
      this.userName = sessionStorage.getItem("LoginName");
    },
    //呼叫登入API
    CheckLogin() {
        let json = {
          TYPE: "CHECKSESSION",
          login_SELECT: {},
        }
        this.FunctionToken(this.functionCheckLogin, json);
    },
    //跳出確認是否登出的訊息
    functionCheckLogin(data) {
      this.apiBackendLogin(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (!json.Status) {
            window.clearInterval(this.timeOutRefresh);
            if(json.Data == "logconfirm") {
              this.message = "您即將登出，是否繼續操作或是直接登出";
              this.logOutConfirm = true;
            } else {
              this.message = "尚未登入";
              this.logOut = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //返回登入頁面
    goHome() {
      this._go("/ISY");
    },
    //登入
    goLogIn() {
      let json = {
        TYPE: "CONTINUEWORK",
        login_SELECT: {},
      }
      this.FunctionToken(this.functionContinueWork, json);  
    },
    //跳出超時登出系統畫面
    functionContinueWork(data) {
      this.apiBackendLogin(data)
        .then((res) => {
          this.logOutConfirm = false;
          const json = JSON.parse(res.data);
          if (!json.Status) {
            this.message = "已超過登入時間，已登出系統";
            this.logOut = true;
          } else 
            this._go(this.$route.fullPath);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //登出
    goLogOut() {
      let json = {
        TYPE: "LOGOUT",
        login_SELECT: {},
      }
      this.FunctionToken(this.functionLogOut, json);
    },
    //呼叫登出API
    functionLogOut(data) {
      this.apiBackendLogin(data)
        .then((res) => {
          this.logOutConfirm = false;
          const json = JSON.parse(res.data);

          this._go("/ISY");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>